import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectUrlSettingService {
  getLoginRedirectUrl(): string {
    return window.location.pathname;
  }
}
